import type { BrandGroup, BrandGroupID } from "models";
import type { DropdownItemProps } from "semantic-ui-react";

const GROUP_VALUE_PREFIX = "group-";

export const sortByName = (a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name);

export const toGroupValue = (brandGroupId: number) => `${GROUP_VALUE_PREFIX}${brandGroupId}`;
export const isGroupValue = (value: string) => value.startsWith(GROUP_VALUE_PREFIX);

export const searchBrandGroups = (options: DropdownItemProps[], query: string) => {
  const search = query.toLowerCase();
  const matches = (option: DropdownItemProps) => typeof option.text === "string" && option.text.toLowerCase().includes(search);

  const filteredOptions: DropdownItemProps[] = [];
  let pendingGroupHeader: DropdownItemProps | null = null;

  options.forEach(option => {
    const isMatch = matches(option);

    if (typeof option.value === "string" && isGroupValue(option.value)) {
      pendingGroupHeader = isMatch ? null : option;
      if (isMatch) filteredOptions.push(option);
      return;
    }

    if (!isMatch) return;

    if (pendingGroupHeader) {
      filteredOptions.push(pendingGroupHeader);
      pendingGroupHeader = null;
    }
    filteredOptions.push(option);
  });

  return filteredOptions;
};

export const getBrandGroupsByIds = (brandGroupIds: BrandGroupID[], brandGroups: BrandGroup[]) => brandGroups.filter(brandGroup => brandGroupIds.includes(brandGroup.id));
const URL_REGEX = /^https?:\/\/[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)*$/;

export const isValidUrl = (url?: string) => !url || URL_REGEX.test(url);
